var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"metadata-widget"},[(_vm.metadata)?_c('Metadata',{attrs:{"metadata":_vm.metadata,"version-urn":_vm.versionUrn}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }